import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { LucideIcon, TrendingUp, TrendingDown } from 'lucide-react'
import { cn } from '@/lib/utils'

interface MetricCardWithDeltaProps {
  title: string
  value: string | number
  description?: string
  icon: LucideIcon
  delta?: {
    value: number // percentage
    isImprovement: boolean // true if green, false if red
  }
  className?: string
}

export function MetricCardWithDelta({
  title,
  value,
  description,
  icon: Icon,
  delta,
  className,
}: MetricCardWithDeltaProps) {
  return (
    <Card className={className}>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">{title}</CardTitle>
        <Icon className="h-4 w-4 text-muted-foreground" />
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">{value}</div>
        {description && (
          <p className="text-xs text-muted-foreground mt-1">{description}</p>
        )}
        {delta && (
          <Badge
            variant="outline"
            className={cn(
              'mt-2 gap-1',
              delta.isImprovement
                ? 'border-green-600 text-green-600 dark:border-green-400 dark:text-green-400'
                : 'border-red-600 text-red-600 dark:border-red-400 dark:text-red-400'
            )}
          >
            {delta.isImprovement ? (
              <TrendingUp className="h-3 w-3" />
            ) : (
              <TrendingDown className="h-3 w-3" />
            )}
            <span className="text-xs font-medium">
              {delta.value > 0 ? '+' : ''}
              {delta.value.toFixed(1)}%
            </span>
          </Badge>
        )}
      </CardContent>
    </Card>
  )
}
